<!-- 使う一覧のSheetの右部ステイタス表示 -->
<template>
  <!-- 使う -->
  <div class="index-ticket-right" @click="goToStampBook(bookGroup)">
    <div class="button__text">
      {{ $t("MyTicketTicketing.StampRally.open") }}
    </div>
  </div>
  <!-- 使う -->
</template>

<script>
import nativeHandlerService from "@/services/nativeHandler";
import { ref, inject, computed, watchEffect, onMounted } from "vue";
import { useStore } from "vuex";

export default {
  name: "SRUseStatusButton",
  props: {
    isPastStamp: {
      type: Boolean,
      default: false,
    },
    bookGroup: {
      type: Object,
      required: true,
    },
    isNotTargetVersion: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props) {
    const openDialogStampRallyVersionWarning = inject(
      "openDialogStampRallyVersionWarning"
    );

    const goToStampBook = (selectedBookGroup) => {
      if (process.env.NODE_ENV == "local") {
        return (window.location.href = `/#/my-tickets/ticketing/${selectedBookGroup.id}/stamp-book`);
      }

      if (props.isNotTargetVersion) {
        openDialogStampRallyVersionWarning();
      } else {
        nativeHandlerService.openStampBook(
          `${process.env.VUE_APP_EMOT2_WEBVIEW_URL}my-tickets/ticketing/${selectedBookGroup.id}/stamp-book`,
          props.isPastStamp
        );
      }
    };

    return {
      goToStampBook,
    };
  },
};
</script>
<style lang="scss" scoped>
.index-ticket-right {
  height: 51px;
  width: calc(23% - 4% - 1px);
  float: left;
  border-left: 1px dashed #d7d7d7;
  position: relative;
  border-radius: 0px 0px 5px 0px;
}

@media screen and (min-width: 421px) {
  .index-ticket-right {
    height: 12vw;
  }
}

.button__text {
  width: 100%;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  font-size: 3.5vw;
  font-weight: bold;
}
</style>
